// extracted by mini-css-extract-plugin
module.exports = {"icon-name-wrapper":"MenuIconCard_icon-name-wrapper__3CdAM","name":"MenuIconCard_name__LG1IF"};